import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";

export default function OverallGrainCard() {
    const [data, setData] = useState({ buy: 0, sell: 0, net: 0 });

    useEffect(() => {
        client.fetch(`*[_type == "grainTransaction"]{buyOrSell, quantity}`)
            .then(items => {
                let b = 0, s = 0;
                items.forEach(i => i.buyOrSell === "Buy" ? b += +i.quantity : s += +i.quantity);
                setData({ buy: b, sell: s, net: s - b });
            });
    }, []);

    return (
        <div className="summary-card-grid">
            <div className="summary-card-item">
                <span className="summary-card-label">Bought</span>
                <span className="summary-card-value text-danger">{data.buy} kg</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Sold</span>
                <span className="summary-card-value text-success">{data.sell} kg</span>
            </div>
            <div className="summary-card-item">
                <span className="summary-card-label">Stock</span>
                {/* <span className="summary-card-value">
                    {data.net} kg
                </span> */}
                <span className={`summary-card-value ${data.net >= 0 ? "text-success" : "text-danger"}`}>
                    {data.net} kg
                </span>
            </div>
        </div>
    );
}